export default __webpack_public_path__ + "static/media/vae2.ebd21294.png";